import React from "react";
import { Moon, Sun } from "lucide-react";
import { useIntl } from "react-intl";

import { useTheme } from "./ThemeContext";
import "./ThemeToggle.scss";

// Sun/Moon button that flips light/dark. `variant="floating"` renders a
// fixed-corner button for pages without a header (auth, public playground).
const ThemeToggle = ({ variant = "inline", className = "" }) => {
  const intl = useIntl();
  const { isDark, toggleTheme } = useTheme();

  const label = intl.formatMessage({
    id: isDark ? "theme_switch_to_light" : "theme_switch_to_dark",
  });

  return (
    <button
      type="button"
      className={`theme_toggle theme_toggle--${variant} ${className}`.trim()}
      onClick={toggleTheme}
      aria-label={label}
      title={label}
    >
      {isDark ? <Sun size={18} /> : <Moon size={18} />}
    </button>
  );
};

export default ThemeToggle;
